import React from 'react';
import { BASE_URL_ATTACH, KYC_STATUS } from '../../../constants/Common';
import UtilService from '../../../services/util';
import OpenNotification from '../../common/CommonButton/OpenNotification';

const CardViewKyc = (props) => {
  const handleFileChange = (e) => {
    let blob = e.target.files[0];

    UtilService.fileMimeType(blob, true, (valid) => {
      if (blob.name.match(/.(pdf|jpg|jpeg|png)$/i)) {
        if (blob.size / 1024 > 5000) {
          OpenNotification({
            type: 'error',
            title: 'File size should be less than 5 mb.',
          });
        } else {
          if (valid) {
            const name = 'user';
            if (blob) {
              var fd = new FormData();
              var img_file = blob;
              fd.append('folder', `${name}`);
              fd.append('file', img_file);
            }
            props.fileApi(fd, name);
          } else {
            OpenNotification({
              type: 'error',
              title: 'File you trying to upload is inappropriate.',
            });
          }
        }
      } else {
        OpenNotification({
          type: 'error',
          title: 'The image should be a PNG, JPG, PDF or JPEG file',
        });
      }
    });
  };
  return (
    <div className="KycCardBlock">
      <div className="kycDetailBox d-flex flex-wrap">
        <div className="kycUploadDoc">
          {props.image ? (
            props.image
              .split('/')
              .slice(-1)[0]
              .match(/.(pdf)$/i) ? (
              <img
                onClick={() => {
                  window.open(`${BASE_URL_ATTACH}/${props.image}`);
                }}
                src={require('../../common/UploadImage/pdf.svg')}
                alt=""
              />
            ) : (
              <img onError={props.removeDoc} src={`${BASE_URL_ATTACH}/${props.image}`} alt="" />
            )
          ) : (
            <img onError={props.removeDoc} src={require('../../../assets/img/user-default.png')} alt="" />
          )}
        </div>
        <div className="kycDetailItem">
          {props.title && (
            <>
              <div className="">
                <div className="companyNameCode">
                  <span>{props.title}</span>
                  {props.isUploaded && (
                    <>
                      {props.isApproved === KYC_STATUS.PENDING ? (
                        <span>(Your Kyc document is under review.)</span>
                      ) : props.isApproved === KYC_STATUS.REJECT ? (
                        <span style={{ color: 'red' }}>(Your Kyc document is rejected.Please upload again)</span>
                      ) : props.isApproved === KYC_STATUS.APPROVED ? (
                        <>
                          <span style={{ marginLeft: '5px' }}>(Your Kyc document is approved)</span>

                          <img
                            style={{ marginLeft: '5px', width: '20px', height: '20px' }}
                            src={require('../../../assets/svg/Account/approvedKyc.svg')}
                            alt=""
                          />
                        </>
                      ) : (
                        <span style={{ marginLeft: '5px' }}>(Its under review.)</span>
                      )}
                    </>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
        {!props.isUploaded && (
          <>
            {props.image ? (
              <div onClick={props.removeDoc} title="Remove Doument" className="detailEditBloxk">
                <img src={require('../../../assets/svg/crossCopy.svg')} alt="" />
              </div>
            ) : (
              <div title="Add Doument" className="detailEditBloxk">
                <input
                  onChange={handleFileChange}
                  type="file"
                  style={{ width: '100%', height: '100%', opacity: 0, position: 'absolute' }}
                />
                <img src={require('../../../assets/svg/plus-thin-copy.svg')} alt="" />
              </div>
            )}
          </>
        )}
        {props.isUploaded && props.isApproved === KYC_STATUS.REJECT && (
          <>
            <div title="Add Doument" className="detailEditBloxk">
              <input
                onChange={handleFileChange}
                type="file"
                style={{ width: '100%', height: '100%', opacity: 0, position: 'absolute' }}
              />
              <img src={require('../../../assets/svg/plus-thin-copy.svg')} alt="" />
            </div>
          </>
        )}
      </div>
    </div>
  );
};
export default CardViewKyc;
